import {Component, EventEmitter, Output} from '@angular/core';
import {LoadingController} from "ionic-angular";
import {CommonProvider} from "../../providers/common/common";
import {AccountProvider} from "../../providers/account/account";
import {FisoMathProvider} from "../../providers/fiso-math/fiso-math";

/**
 * Generated class for the ParentComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'fiso-parent',
    templateUrl: 'parent.html',
    providers: [FisoMathProvider]
})
export class ParentComponent {

    @Output() onClose = new EventEmitter();

    profile: any = {};
    uuid: any = null;

    constructor(public loadingCtrl: LoadingController,
                public commonProvider: CommonProvider,
                public accountProvider: AccountProvider,
                public fisoMathProvider: FisoMathProvider) {
        this.uuid = this.commonProvider.generateGuid();
        console.log('Hello ParentComponent Component');

        this.accountProvider.loadProfile().subscribe(
            (resp: any) => {
                if (!resp.status) {
                    return;
                }

                const {data} = resp;
                this.profile = {
                    username: data.metas.student_username,
                    fullname: data.title,
                    father_image_url: data.metas.father_image_url,
                    mother_image_url: data.metas.mother_image_url,
                    email: data.metas.student_parent_email,
                    phone: data.metas.student_parent_phone,
                    address: data.metas.student_parent_address,
                    thumbnail_url: data.thumbnail_url
                };
            },
            err => {
                console.log(err);
            }
        );
    }

    select(code) {
        window.localStorage.setItem('PARENT_MODE', code);

        this.fisoMathProvider.parentLog({
            title: ``,
            excerpt: code,
        }).subscribe();

        this.onClose.emit();
    }


    fileChanged(field = 'father_image_url', e: Event) {
        let loader = this.loadingCtrl.create({
            content: "Vui lòng chờ giây lát ..."
        });
        loader.present();

        let target: HTMLInputElement = e.target as HTMLInputElement;
        for (let i = 0; i < target.files.length; i++) {
            console.log(target.files[i]);
            this.commonProvider.uploadImage(target.files[i], resp => {
                loader.dismiss();
                if (!resp.status) {
                    return;
                }

                document.getElementById(`${field}_${this.uuid}`)['value'] = '';
                this.profile[field] = resp.data.image_url;
                this.accountProvider.updateProfile(this.profile).subscribe(resp => {
                    console.log(resp);
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/parent/parent.ts